<template>
  <div class="app">
    <AppHeader fixed>
       <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard/">
        <img
          class="navbar-brand-full"
          src="img/brand/Harmonic.jpg"
          width="100"
          height="45"
          alt="CoreUI Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/part.png"
          width="20"
          height="20"
          alt="Fiber Node Services"
        />
      </b-link>
       <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
        <b-navbar-nav class="d-md-down-none">
      <b-form-input
          style="display:inline-block; width:150px;margin-left:150px"
          v-model="searchQuery"
          type="search"
          id="filterInput"
          placeholder="Type to Search"
        ></b-form-input>
        <b-form-select id="basicSelect"
          :plain="true"
          :options="[{text:'S/N', value:'serial'}, {text:'RA#', value:'ra'}, {text:'Invoice#', value:'inv'}, {text:'HAR ID', value:'harid'}]"
          placeholder="Please select"
          v-model="selected"
          text-field="text"
          value-field="value">
        </b-form-select>
        <b-button
        :disabled="searchQuery ? false : true"
          @click="searchFor()"
        >Search </b-button>
        <!--        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <!--        <b-nav-item class="px-3">Settings</b-nav-item>-->
      </b-navbar-nav>
      <b-navbar-nav class="d-md-down-none" style="margin:auto;">
        <!-- <b-nav-item class="px-3" style="background:#2f353a; padding: 8px 15px; border-radius:6px;" to="/dashboard"><i style="color: white;" class="icon-speedometer"></i> Alpha Portal</b-nav-item>
        <b-nav-item class="px-3" style="background:#2f353a; padding: 8px 15px; border-radius:6px; margin-left:5px" to="/base/map"><i style="color: white;" class="icon-map"></i> Map Overview</b-nav-item>
        <b-nav-item class="px-3" style="background:#2f353a; padding: 8px 15px; margin-left:5px; border-radius:6px;" to="/analyticsByModel"><i style="color: white;" class="icon-layers"></i> Models Analytics </b-nav-item>
        <b-nav-item class="px-3" style="background:#2f353a; padding: 8px 15px; border-radius:6px; margin-left:5px" to="/base/backlog"><i style="color: white;" class="icon-layers"></i> Backlog</b-nav-item>
        <b-nav-item class="px-3" style="background:#2f353a; padding: 8px 15px; border-radius:6px; margin-left:5px" to="/base/ber"><i style="color: white;" class="icon-chart"></i> B.E.R.</b-nav-item>
        <b-nav-item class="px-3" style="background:#2f353a; padding: 8px 15px; border-radius:6px; margin-left:5px" to="/base/eol"><i style="color: white;" class="icon-chart"></i> E.O.L.</b-nav-item>
        <b-nav-item class="px-3" style="background:#2f353a; padding: 8px 15px; border-radius:6px; margin-left:5px" to="/base/war"><i style="color: white;" class="icon-chart"></i> Under Warranty</b-nav-item> -->


        <!--        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <!--        <b-nav-item class="px-3">Settings</b-nav-item>-->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!--        <b-nav-item class="d-md-down-none">-->
        <!--          <i class="icon-bell"></i>-->
        <!--          <b-badge pill variant="danger">5</b-badge>-->
        <!--        </b-nav-item>-->
        <!--        <b-nav-item class="d-md-down-none">-->
        <!--          <i class="icon-list"></i>-->
        <!--        </b-nav-item>-->
        <!--        <b-nav-item class="d-md-down-none">-->
        <!--          <i class="icon-location-pin"></i>-->
        <!--        </b-nav-item>-->
        <!-- <b-nav-item class="d-md-down-none">
         <span class="mr-1">{{full_name}}</span>
        </b-nav-item> -->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!--      <AsideToggler class="d-none d-lg-block" />-->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
       <AppSidebar>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav style="width: 230px" :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <div style="padding-top: 17px" class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
      </div>
      <div class="ml-auto">
        <a :href="fiberNodeLink" >Fiber Node Services Inc.</a>
        <span class="ml-1">&copy; 2020</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
  import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import axi from 'axios'
export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      full_name: "",
      ip:"",
      selected: 'serial',
      searchQuery: null,
      fiberNodeLink: process.env.VUE_APP_TRACKER_URL + "main/"
    };
  },
  methods:{
    searchFor() {
      this.$router.push('/search/?type=' + this.selected + '&value=' + this.searchQuery)
    },

    getUserData () {
      axi.get('https://www.cloudflare.com/cdn-cgi/trace')
          .then(res => {
            const ipRegex = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/
            const IP = res.data.match(ipRegex)[0];
            this.ip=IP;
            this.logData();
          })
    },
    logData() {
      let formData = new FormData();
      formData.append("portal", 'HAR');
      formData.append("ip", this.ip);
      formData.append("user", localStorage.getItem('har_user'));
      console.log(this.ip);
      console.log(localStorage.getItem('har_user'));
      this.$http.post(process.env.VUE_APP_TRACKER_URL + 'api/logUser.php',formData)
          .then((response) => {
            console.log(response)
          }).catch(err => {
        console.log(err)
      })
    }},
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  mounted() {
    this.full_name = localStorage.getItem("har_full_name");
  },
  created() {
    this.getUserData();
  }
};
</script>

<style>
.sidebar .nav {
  width: 225px;
}
html:not([dir="rtl"]) .sidebar {
  margin-left: -225px;
}
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .sidebar-nav {
    overflow: visible;
    width: 50px !important;
  }
}
</style>
